import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, OnDestroy } from '@angular/core';
import { ChartConfiguration, LineControllerDatasetOptions } from 'chart.js/auto';
import { Icons } from '../../icon/constants/icons.constants';
import { IconComponent } from '../../icon/icon.component';
import { LogoLoadingComponent } from '../../logo-loading/logo-loading.component';
import { BaseChartComponent } from '../base/base-chart.component';
import { COLORS } from '../constants/chart.constants';

@Component({
    selector: 'nw-line-chart',
    templateUrl: '../base/base-chart.component.html',
    styleUrl: '../base/base-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LogoLoadingComponent, IconComponent],
    host: {
        class: 'chart__container'
    }
})
export class LineChartComponent
    extends BaseChartComponent<'bar', LineControllerDatasetOptions>
    implements OnDestroy, OnChanges
{
    public override icon: Icons.Type = Icons.Charts.line;

    public override datasetDefaults = (
        index: number
    ): Partial<LineControllerDatasetOptions> => {
        const POINT_RADIUS: number[] = [
            ...((this.datasets?.length ? this.datasets[0] : undefined)?.data?.map(
                () => 0
            ) || [0])
        ];
        POINT_RADIUS.pop();
        POINT_RADIUS.push(4);

        return {
            borderColor: COLORS[index % COLORS.length],
            backgroundColor: COLORS[index % COLORS.length],
            borderWidth: 2,
            tension: 0.4,
            cubicInterpolationMode: 'monotone',
            fill: false,
            pointStyle: 'circle',
            pointRadius: POINT_RADIUS
        };
    };

    public override configDefaults(): Partial<ChartConfiguration> {
        return {
            type: 'line',
            options: {
                scales: {
                    x: {
                        border: {
                            color: this.theme === 'dark' ? '#787f87' : undefined
                        }
                    },
                    y: {
                        border: {
                            color: this.theme === 'dark' ? '#787f87' : undefined
                        }
                    }
                }
            }
        };
    }
}
